import request from '@/utils/request'
import { useFd } from '@/utils/formData'

export function fetchOwnerList () {
  const data = useFd('AEW/Client/OwnerList', {
    __ds: 'site',
    __dbid: '2'
  })
  return request({
    method: 'post',
    data,
  })
}

export function fetchGrantList ({ ownerId, range = 0, take = 10, page = 1, kw }) {
  const data = useFd('AEW/Client/GrantList', {
    __ds: 'site',
    __dbid: '2',
    ownerid: ownerId,
    range,
    get_total_num: take,
    page,
    search_kw: kw
  })
  return request({
    method: 'post',
    data,
  })
}


// 補助的詳細資料
export function fetchGrantDetail ({ grantId }) {
  const data = useFd('AEW/Client/GrantDetail', {
    __ds: 'site',
    __dbid: '2',
    grant_id: grantId,

  })
  return request({
    method: 'post',
    data,
  })
}


//申請補助狀態List
export function fetchGrantApplicationList ({ grantId, type = 0, u_str, take = 10, page = 1, kw }) {
  const data = useFd('AEW/Client/GrantApplicationList', {
    __ds: 'site',
    __dbid: '2',
    grant_id: grantId,
    u_str,
    type,
    get_total_num: take,
    page,
    search_kw: kw

  })
  return request({
    method: 'post',
    data,
  })
}


//申請補助細節
export function fetchGrantApplicationDetail ({ u_str, applicationId, type = 1 }) {
  const data = useFd('AEW/Client/GrantApplicationDetail', {
    __ds: 'site',
    __dbid: '2',
    u_str,
    application_id: applicationId,
    get_result_info: type,
  })
  return request({
    method: 'post',
    data,
  })
}


//找補助-申請
export function updateGrantApplication (payload, addFiles, deleteFileIds) {
  const {
    u_str, grant_id, application_id, city, org_type, org_name, org_number, boss, address, activity_name, activity_class, activity_type, activity_hours, activity_counter, activity_number, activity_amount, ticket_income, subsidy, old_subsidy, activity_starttime, activity_endtime, self_raising, subsidy_other, contact_name, contact_phone, contact_email, contact_passwd, city_contact_info
  } = payload
  const data = useFd('AEW/Client/GrantApplicationUpdate', {
    __ds: 'site',
    __dbid: 2,
    u_str,
    grant_id,
    application_id,
    city, org_type, org_name, org_number, boss, address,
    activity_name,
    activity_class: JSON.stringify(activity_class),
    activity_type: JSON.stringify(activity_type),
    activity_hours, activity_counter, activity_number, activity_amount, ticket_income, subsidy,
    old_subsidy: JSON.stringify(old_subsidy),
    activity_starttime, activity_endtime, self_raising, subsidy_other, contact_name, contact_phone,
    contact_email,
    contact_passwd,
    city_contact_info: JSON.stringify(city_contact_info)
  })
  if (addFiles.length > 0) {
    addFiles.forEach(f => {
      data.append('add_att_file[]', f)
    })
  }
  if (deleteFileIds.length > 0) {
    deleteFileIds.forEach(id => {
      data.append('del_att_id[]', id)
    })
  }
  return request({
    method: 'post',
    data,
  })
}


export function login ({ email, psw }) {
  const data = useFd('AEW/Client/GrantUserLogin', {
    __ds: 'center',
    __dbid: '0',
    email,
    password: psw,
    __ds_origin: null,
    __dsid_origin: null
  })
  return request({
    method: 'post',
    data,
  })
}

// 忘記密碼
export function forgotPassword ({ email }) {
  const data = useFd('AEW/Client/GrantForgotPassword', {
    email,
    __ds: 'center',
    __dbid: '0',
    __ds_origin: null,
    __dsid_origin: null
  })
  return request({
    method: 'post',
    data,
  })
}

export function uploadGrantApplicationResult ({ payload, addFiles=[], addFileMemos=[], deleteFileIds=[], addVideos=[] }) {
  const {
    u_str,
    application_id,
    missive_code,
    activity_name,
    activity_starttime,
    activity_endtime,
    activity_location,
    activity_counter,
    result_memo
  } = payload
  const data = useFd('AEW/Client/GrantApplicationResultUpload', {
    __ds: 'site',
    __dbid: '2',
    u_str,
    application_id,
    missive_code,
    activity_name,
    activity_starttime,
    activity_endtime,
    activity_location,
    activity_counter,
    result_memo,
  })
  addFiles.forEach(e => {
    data.append('add_att_file[]', e)
  })

  addFileMemos.forEach(e => {
    data.append('add_att_memo[]', e)
  })

  deleteFileIds.forEach(e => {
    data.append('del_att_id[]', e)
  })

  addVideos.forEach((video, i) => {
    if (video.url) {
      data.append(`add_video${i + 1}[url]`, video.url)
      data.append(`add_video${i + 1}[id]`, video.id || '')
    }
  })

  return request({
    method: 'post',
    data,
  })
}

export function fetchGrantApplicationResultList ({ ownerId, page, keyword }) {
  const data = useFd('AEW/Client/GrantApplicationResultList', {
    ownerid: ownerId,
    search_kw: keyword,
    get_total_num: page  || undefined,
    page,
    __ds: 'site',
    __dbid: 2,
  })
  return request({
    method: 'post',
    data,
  })
}




export function fetchGrantApplicationResultDetail ({ applicationId }) {
  const data = useFd('AEW/Client/GrantApplicationResultDetail', {
    application_id: applicationId,
    __ds: 'site',
    __dbid: 2,
  })
  return request({
    method: 'post',
    data,
  })
}




// WEBPACK FOOTER //
// ./src/api/client/Grant.js